import { render, staticRenderFns } from "./OrgFeeProjection.vue?vue&type=template&id=413f459f&scoped=true&"
import script from "./OrgFeeProjection.vue?vue&type=script&lang=js&"
export * from "./OrgFeeProjection.vue?vue&type=script&lang=js&"
import style0 from "./OrgFeeProjection.vue?vue&type=style&index=0&id=413f459f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f459f",
  null
  
)

export default component.exports